"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _SyncIcon, _CloseIcon;
/* eslint-disable jsx-a11y/media-has-caption */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)({
  closeButton: {
    color: 'white',
    position: 'absolute',
    right: 0,
    zIndex: 2
  },
  container: {
    minHeight: 216,
    overflow: 'hidden',
    position: 'relative'
  },
  hidden: {
    display: 'none'
  },
  switchButton: {
    color: 'white',
    left: 0,
    position: 'absolute',
    zIndex: 2
  },
  video: {
    backgroundColor: '#232528',
    bottom: 0,
    height: 'auto',
    left: '50%',
    minHeight: '100%',
    minWidth: '100%',
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(-50%,-50%)',
    width: 'auto'
  }
});
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var containerClassName = _ref.containerClassName,
    hidden = _ref.hidden,
    id = _ref.id,
    onClose = _ref.onClose,
    onSwitch = _ref.onSwitch;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.container, containerClassName, {
      [classes.hidden]: hidden
    }),
    id: "".concat(id, "Container")
  }, onSwitch && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    className: classes.switchButton,
    color: "inherit",
    id: "".concat(id, "SwitchButton"),
    onClick: onSwitch,
    size: "large"
  }, _SyncIcon || (_SyncIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Sync, null))), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    className: classes.closeButton,
    color: "inherit",
    id: "".concat(id, "CloseButton"),
    onClick: onClose,
    size: "large"
  }, _CloseIcon || (_CloseIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Close, null))), /*#__PURE__*/_react.default.createElement("video", {
    ref: ref,
    className: classes.video,
    id: "".concat(id, "Video")
  }));
});